import React from 'react';
import {
  CatalogFilterLayout,
  EntityOwnerPicker,
  EntityTagPicker,
  EntityListProvider,
  EntityKindPicker,
  EntityTypePicker,
  UserListPicker,
  EntityLifecyclePicker,
  EntityProcessingStatusPicker,
  EntityNamespacePicker,
} from '@backstage/plugin-catalog-react';
import {
  FullPage,
  PageHeader,
  MaterialIcon,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';
import { CatalogTable } from '@backstage/plugin-catalog';
import { useNavigate } from 'react-router-dom';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const CatalogHomePage = (): React.ReactElement => {
  const orgName =
    useApi(configApiRef).getOptionalString('organization.name') ?? 'Backstage';
  const navigate = useNavigate();

  const createFromTemplate = () => {
    navigate('/create?filters%5Bkind%5D=template&filters%5Buser%5D=all');
  };

  return (
    <FullPage
      variant="card"
      HeaderComponent={() => (
        <PageHeader
          subtitle="Catalog"
          title={orgName}
          icon={<MaterialIcon.menu_book />}
          headerActionProps={{
            actionItems: [
              {
                label: 'Create component',
                icon: <MaterialIcon.AddRounded />,
                onClick: createFromTemplate,
              },
            ],
          }}
        />
      )}
    >
      <EntityListProvider>
        <CatalogFilterLayout>
          <CatalogFilterLayout.Filters>
            <EntityKindPicker initialFilter="Component" />
            <EntityTypePicker initialFilter="all" />
            <UserListPicker initialFilter="all" />
            <EntityOwnerPicker />
            <EntityLifecyclePicker />
            <EntityTagPicker />
            <EntityProcessingStatusPicker />
            <EntityNamespacePicker />
          </CatalogFilterLayout.Filters>
          <CatalogFilterLayout.Content>
            <CatalogTable />
          </CatalogFilterLayout.Content>
        </CatalogFilterLayout>
      </EntityListProvider>
    </FullPage>
  );
};
